import React, { Component } from 'react';
import { MDBDataTable } from "mdbreact";
import { connect } from "react-redux";
import i18n from "i18next";

class TopUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            topUserFilter: "Spending"
        };
    };

    handleChange = e => {
        this.setState({
            ...this.state,
            [e.target.id]: e.target.value
        });
    };

    render() {

        let data = {
            columns: [],
            rows: []
        }

        if (this.state.topUserFilter === "Stamps") {

            data.columns = [
                {
                    label: i18n.t("Top Users"),
                    field: "topUsers",
                    sort: "asc"
                },
                {
                    label: i18n.t("User name"),
                    field: "username",
                    sort: "asc"
                },
                {
                    label: i18n.t("Number"),
                    field: "number",
                    sort: "asc"
                },
                {
                    label: i18n.t("Email"),
                    field: "email",
                    sort: "asc"
                },
                {
                    label: i18n.t("Stamps"),
                    field: "stamps",
                    sort: "asc"
                }
            ]

            data.rows = this.props.topUserData.sortByStamps

        } else if (this.state.topUserFilter === "Spending") {

            data.columns = [
                {
                    label: i18n.t("Top Users"),
                    field: "topUsers",
                    sort: "asc"
                },
                {
                    label: i18n.t("User name"),
                    field: "username",
                    sort: "asc"
                },
                {
                    label: i18n.t("Number"),
                    field: "number",
                    sort: "asc"
                },
                {
                    label: i18n.t("Email"),
                    field: "email",
                    sort: "asc"
                },
                {
                    label: i18n.t("Spending"),
                    field: "spending",
                    sort: "asc"
                }
            ]

            data.rows = this.props.topUserData.sortBySpending
        }


        return (
            <div>
                <div>
                    <h6 className="text-center">{i18n.t("Top Users")}</h6>
                    <div>
                        <label htmlFor="topUserFilter">{i18n.t("Sort by")}: </label>
                        <select id="topUserFilter" name="topUserFilter" className="browser-default form-select" value={this.state.topUserFilter} onChange={this.handleChange}>
                            <option value="Spending">{i18n.t("Spending")}</option>
                            {this.props.admin.admin.stamp ? <option value="Stamps">{i18n.t("Stamps")}</option> : null}
                        </select>
                    </div>
                </div>

                <div className="text-center mt-3"><MDBDataTable data={data} paging={false} searching={false} sortable={false} noBottomColumns striped hover responsive bordered /></div>

            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        admin: state.admin
    };
};

export default connect(mapStateToProps, null)(TopUser);